/* VORYNEX Guides (2026-10-21) — interactive parts of the "guide" article template and the guides hub.
   No libraries. Each part starts when it comes near the screen. Config comes from <script id="vg-config" type="application/json"> (texts, product,
   prices, cart routes) written by sections/vpx-guide.liquid. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('vg-config');
  var C = cfgEl ? JSON.parse(cfgEl.textContent) : {};
  var T = C.t || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;
  var root = (C.root || '/').replace(/\/?$/, '/');
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var fmt = function (n, d) { return Number(n).toLocaleString(C.locale || 'el-GR', { maximumFractionDigits: d == null ? 0 : d }); };
  var money = function (cents) { return (cents / 100).toLocaleString(C.locale || 'el-GR', { style: 'currency', currency: C.currency || 'EUR' }); };
  var ENT = { amp: '&', '#39': "'", quot: '"', lt: '<', gt: '>' };
  // the Liquid t filter HTML-escapes the strings in the JSON config; every caller writes them as text
  var tr = function (key, vars) { var s = String(T[key] || key).replace(/&(amp|#39|quot|lt|gt);/g, function (m, k) { return ENT[k]; }); Object.keys(vars || {}).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); }); return s; };
  function whenNear(el, fn) {
    if (!el) return;
    if (!('IntersectionObserver' in window)) return fn(el);
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); fn(el); } }); }, { rootMargin: '300px 0px' });
    io.observe(el);
  }
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k) || 'null'); sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } return null; }

  /* ---------- reading progress fallback (browsers without CSS scroll timelines) ---------- */
  var bar = $('.vg-progress span');
  if (bar && !(window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()')) && !reduce) {
    var ticking = false;
    var paint = function () { ticking = false; var h = document.documentElement; var p = h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight); bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)) + ')'; };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }, { passive: true });
    paint();
  }

  /* ---------- table of contents: ids for h2 + active section ---------- */
  var toc = $('[data-vg-toc]');
  var heads = $$('.vg-prose h2');
  if (toc && heads.length) {
    var used = {};
    var list = $('[data-vg-toc-list]', toc);
    heads.forEach(function (h, i) {
      if (!h.id) {
        var base = (h.textContent || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9Ͱ-Ͽἀ-῿]+/g, '-').replace(/^-|-$/g, '').slice(0, 48) || 'section-' + i;
        var id = base, n = 2; while (used[id] || document.getElementById(id)) id = base + '-' + n++;
        used[id] = 1; h.id = id;
      }
      var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent; list.appendChild(a);
    });

    if ('IntersectionObserver' in window) {
      var links = $$('a', list);
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id); });
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      heads.forEach(function (h) { io.observe(h); });
    }
    list.addEventListener('click', function (e) { var d = e.target.closest('details'); if (d && window.innerWidth < 990) d.open = false; });
  }

  /* ---------- hero stage: loop video after the page has settled, pointer parallax ---------- */
  var stage = $('[data-vg-stage]');
  if (stage) {
    var vid = $('video', stage);
    var conn = navigator.connection || {};
    var canPlay = vid && !reduce && !conn.saveData && !/2g/.test(conn.effectiveType || '');
    var startVideo = function () {
      if (!canPlay || vid.dataset.started) return;
      vid.dataset.started = '1';
      $$('source[data-src]', vid).forEach(function (s) { s.src = s.dataset.src; });
      vid.load();
      vid.addEventListener('playing', function () { vid.classList.add('is-on'); }, { once: true });
      var p = vid.play(); if (p && p.catch) p.catch(function () {});
    };
    var later = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
    if (document.readyState === 'complete') later(startVideo); else window.addEventListener('load', function () { later(startVideo); });
    if (stage.classList.contains('vg-stage--day') && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { stage.classList.toggle('is-off', !e.isIntersecting); }); }).observe(stage);
    }
    if (vid && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (!vid.dataset.started) return; if (e.isIntersecting) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); } else vid.pause(); }); }).observe(stage);
    }
    if (fine && !reduce) {
      var raf = 0;
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { stage.style.setProperty('--mx', x.toFixed(3)); stage.style.setProperty('--my', y.toFixed(3)); });
      });
      stage.addEventListener('pointerleave', function () { stage.style.setProperty('--mx', 0); stage.style.setProperty('--my', 0); });
    }
  }

  /* ---------- cart ---------- */
  function addToCart(items, statusEl, btn) {
    if (btn) btn.disabled = true;
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'vpx-guide', data: { source: 'vpx-guide', itemCount: cart.item_count } } }));
        if (statusEl) { statusEl.hidden = false; statusEl.className = 'vg-done'; statusEl.innerHTML = '✓ ' + tr('added') + ' · <a href="' + root + 'cart">' + tr('view_cart') + '</a>'; }
        paintGift(cart);
      })
      .catch(function () { if (statusEl) { statusEl.hidden = false; statusEl.className = 'vg-small'; statusEl.textContent = tr('add_error'); } })
      .then(function () { if (btn) btn.disabled = false; });
  }

  /* flavour pickers (lab, product card, sticky bar share one choice) */
  var P = C.product || null;
  var chosen = P && P.flavours && P.flavours.length ? (P.flavours.filter(function (f) { return f.current; })[0] || P.flavours[0]) : null;
  function paintFlavours() {
    $$('[data-vg-flavours]').forEach(function (box) {
      $$('button', box).forEach(function (b) { b.setAttribute('aria-pressed', String(chosen && b.dataset.variant === String(chosen.variant))); });
      var name = $('span', box); if (name && chosen) name.textContent = chosen.name;
    });
    $$('[data-vg-flavour-img]').forEach(function (img) { if (chosen && chosen.image) img.src = chosen.image; });
  }
  if (P && P.flavours) {
    $$('[data-vg-flavours]').forEach(function (box) {
      if (P.flavours.length < 2) { box.hidden = true; return; }
      P.flavours.forEach(function (f) {
        var b = document.createElement('button'); b.type = 'button'; b.dataset.variant = f.variant; b.style.setProperty('--sw', f.color || '#ccc');
        b.setAttribute('aria-label', f.name); b.title = f.name;
        b.addEventListener('click', function () { chosen = f; paintFlavours(); });
        box.appendChild(b);
      });
      var lbl = document.createElement('span'); box.appendChild(lbl);
    });
    paintFlavours();
  }

  /* ---------- Protein Lab ---------- */
  whenNear($('[data-vg-lab]'), function (lab) {
    var w = $('[data-vg-w]', lab), f = $('[data-vg-f]', lab);
    var on = $('[data-vg-goal][aria-pressed="true"]', lab), goal = on ? Number(on.dataset.vgGoal) : 1.6;
    var age = 'adult';
    var saved = store('vg-lab'); if (saved) { w.value = saved.w; f.value = saved.f; goal = saved.g; age = saved.a || 'adult'; $$('[data-vg-goal]', lab).forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.vgGoal) === goal)); }); $$('[data-vg-age]', lab).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.vgAge === age)); }); }
    var C2 = 2 * Math.PI * 84;
    var shown = 0;
    function tick(to) {
      var el = $('[data-vg-total]', lab), from = shown; shown = to;
      if (reduce) { el.textContent = fmt(to) + ' g'; return; }
      var t0 = performance.now();
      (function step(t) { var k = Math.min(1, (t - t0) / 650); k = 1 - Math.pow(1 - k, 3); el.textContent = fmt(Math.round(from + (to - from) * k)) + ' g'; if (k < 1) requestAnimationFrame(step); })(t0);
    }
    function draw() {
      var kg = Number(w.value), share = Number(f.value) / 100;
      // From 65, expert groups (PROT-AGE) advise at least 1.0 g/kg, so the base goal rises for older readers.
      var g = age === 'senior' ? Math.max(goal, 1.0) : goal;
      var need = Math.round(kg * g), gap = need * (1 - share);
      var scoops = Math.round(gap / (C.scoopProtein || 23) * 2) / 2;
      var tooMuch = scoops > 2;
      if (tooMuch) scoops = 2;
      $('[data-vg-w-out]', lab).textContent = kg + ' kg';
      $('[data-vg-f-out]', lab).textContent = Math.round(share * 100) + '%';
      tick(need);
      var max = 300, foodLen = C2 * Math.min(1, need * share / max), shakeLen = C2 * Math.min(1, (need * share + scoops * (C.scoopProtein || 23)) / max) - foodLen;
      var food = $('.food', lab), fg = $('.fg', lab);
      food.style.strokeDasharray = foodLen + ' ' + C2;
      fg.style.strokeDasharray = Math.max(0, shakeLen) + ' ' + C2;
      fg.style.strokeDashoffset = -foodLen;
      var res = $('[data-vg-res]', lab), days = $('[data-vg-days]', lab);
      if (scoops <= 0) { res.textContent = tr('lab_food_ok'); days.textContent = tr('lab_food_ok_sub'); }
      else {
        res.textContent = tr(scoops === 1 ? 'lab_scoop_one' : 'lab_scoops', { n: fmt(scoops, 1), g: fmt(Math.round(scoops * (C.scoopProtein || 23))) });
        days.textContent = tr('lab_days', { d: Math.floor((C.servings || 33) / scoops) }) + (tooMuch ? ' · ' + tr('lab_too_much') : '');
      }
      var tubs = scoops > 0 ? Math.max(1, Math.ceil(30 * scoops / (C.servings || 33))) : 1;
      lab.dataset.tubs = tubs;
      var once = $('[data-vg-buy-once]', lab), sub = $('[data-vg-buy-sub]', lab);
      if (P && once) once.textContent = tr('buy_once', { n: tubs, p: money(P.price * tubs) });
      if (P && sub) { sub.hidden = !P.plan; if (P.plan) sub.textContent = tr('buy_sub', { n: tubs, pct: P.planPct, p: money(P.planPrice * tubs) }); }
      $('[data-vg-ring-sub]', lab).textContent = tr('lab_per_day');
      var sn = $('[data-vg-senior]', lab); if (sn) sn.hidden = !(age === 'senior' && goal < 1.0);
      var state = { w: kg, f: Math.round(share * 100), g: goal, a: age, need: need, scoops: scoops };
      store('vg-lab', state); window.vgLab = state;
      document.dispatchEvent(new CustomEvent('vg:lab', { detail: state }));
    }
    $$('[data-vg-goal]', lab).forEach(function (b) {
      b.addEventListener('click', function () { goal = Number(b.dataset.vgGoal); $$('[data-vg-goal]', lab).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); }); draw(); });
    });
    $$('[data-vg-age]', lab).forEach(function (b) {
      b.addEventListener('click', function () { age = b.dataset.vgAge; $$('[data-vg-age]', lab).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); }); draw(); });
    });
    w.addEventListener('input', draw); f.addEventListener('input', draw);
    var st = $('[data-vg-status]', lab);
    var once = $('[data-vg-buy-once]', lab), sub = $('[data-vg-buy-sub]', lab);
    if (once) once.addEventListener('click', function () { if (chosen) addToCart([{ id: Number(chosen.variant), quantity: Number(lab.dataset.tubs || 1) }], st, once); });
    if (sub) sub.addEventListener('click', function () { if (chosen && P.plan) addToCart([{ id: Number(chosen.variant), quantity: Number(lab.dataset.tubs || 1), selling_plan: Number(P.plan) }], st, sub); });
    draw();
  });

  /* ---------- Creatine Lab: consistent daily use fills muscle stores in ~3-4 weeks (illustrative model) ---------- */
  whenNear($('[data-vg-crlab]'), function (box) {
    var dose = 5, week = 7, cal = $('[data-vg-cal]', box), dots = [];
    for (var i = 0; i < 56; i++) { var d = document.createElement('i'); cal.appendChild(d); dots.push(d); }
    var day = $('[data-vg-day]', box);
    function taken(n) { return (n % 7) < week; } // day index 0..55, the first `week` days of each week
    function draw() {
      var now = Number(day.value), count = 0, need = dose >= 5 ? 21 : 28, fullDay = 0;
      dots.forEach(function (d, i) {
        var past = i < now, t = taken(i);
        if (past && t) { count++; if (count === need) fullDay = i + 1; }
        d.className = !past ? 'is-future' : (t ? 'is-taken' : 'is-skip');
        if (i === now - 1) d.className += ' is-today';
      });
      var p = Math.min(1, count / need);
      $('[data-vg-day-out]', box).textContent = now;
      $('[data-vg-sat]', box).style.transform = 'scaleX(' + p.toFixed(3) + ')';
      $('[data-vg-sat-pct]', box).textContent = Math.round(p * 100) + '%';
      var res = $('[data-vg-cl-res]', box);
      if (p >= 1) res.textContent = tr('cl_full', { d: fullDay });
      else { var left = Math.ceil((need - count) / (week / 7)); res.textContent = tr('cl_progress', { n: count, d: left }); }
      $('[data-vg-cl-tub]', box).textContent = dose >= 5 ? tr('cl_tub_powder') : tr('cl_tub_gummies');
      var once = $('[data-vg-cl-once]', box), sub = $('[data-vg-cl-sub]', box);
      if (once) {
        // One-time purchases only in the guides (subscriptions stay on the product page; never shown for DE, §312k).
        if (dose >= 5 && P) once.textContent = tr('buy_once', { n: 1, p: money(P.price) });
        else if (box.dataset.gumVariant) once.textContent = tr('buy_gummies', { p: money(Number(box.dataset.gumPrice)) });
      }
    }
    $$('[data-vg-dose]', box).forEach(function (b) { b.addEventListener('click', function () { dose = Number(b.dataset.vgDose); $$('[data-vg-dose]', box).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); }); draw(); }); });
    $$('[data-vg-week]', box).forEach(function (b) { b.addEventListener('click', function () { week = Number(b.dataset.vgWeek); $$('[data-vg-week]', box).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); }); draw(); }); });
    day.addEventListener('input', draw);
    var st = $('[data-vg-status]', box), once = $('[data-vg-cl-once]', box), sub = $('[data-vg-cl-sub]', box);
    if (once) once.addEventListener('click', function () {
      if (dose >= 5 && chosen) addToCart([{ id: Number(chosen.variant), quantity: 1 }], st, once);
      else if (box.dataset.gumVariant) addToCart([{ id: Number(box.dataset.gumVariant), quantity: 1 }], st, once);
    });
    if (sub) sub.addEventListener('click', function () { if (chosen && P.plan) addToCart([{ id: Number(chosen.variant), quantity: 1, selling_plan: Number(P.plan) }], st, sub); });
    draw();
  });

  /* ---------- Caffeine Planner: one serving + coffees, half-life ~5 h, EFSA 400 mg/day for healthy adults ---------- */
  whenNear($('[data-vg-cflab]'), function (box) {
    var MG = Number(box.dataset.mg || 149), CUP = 80, HALF = 5, X0 = 20, X1 = 310, T0 = 6, T1 = 26, Y0 = 140, Y1 = 22, YMAX = 320;
    var train = $('[data-vg-cf-train]', box), bed = $('[data-vg-cf-bed]', box), cups = 1;
    var hh = function (h) { h = ((h % 24) + 24) % 24; var m = Math.round((h % 1) * 60); return String(Math.floor(h)).padStart(2, '0') + ':' + String(m).padStart(2, '0'); };
    var x = function (h) { return X0 + (h - T0) / (T1 - T0) * (X1 - X0); };
    var y = function (mg) { return Y0 - Math.min(mg, YMAX) / YMAX * (Y0 - Y1); };
    var ticks = $('[data-vg-cf-ticks]', box);
    [6, 10, 14, 18, 22, 26].forEach(function (h) { var t = document.createElementNS('http://www.w3.org/2000/svg', 'text'); t.setAttribute('x', x(h)); t.setAttribute('y', 156); t.textContent = hh(h); ticks.appendChild(t); });
    function doses() {
      var list = [], dose = Number(train.value) - 0.4;
      for (var i = 0; i < cups; i++) list.push([8 + i * 2.5, CUP]);
      list.push([dose, MG]);
      return { list: list, dose: dose };
    }
    function level(list, t) { return list.reduce(function (s, d) { return t >= d[0] ? s + d[1] * Math.pow(0.5, (t - d[0]) / HALF) : s; }, 0); }
    function draw() {
      var d = doses(), b = Number(bed.value), path = '';
      for (var t = T0; t <= T1 + 0.001; t += 0.25) path += (path ? 'L' : 'M') + x(t).toFixed(1) + ' ' + y(level(d.list, t)).toFixed(1);
      $('[data-vg-cf-curve]', box).setAttribute('d', path);
      $('[data-vg-cf-area]', box).setAttribute('d', path + 'L' + x(T1) + ' ' + Y0 + 'L' + x(T0) + ' ' + Y0 + 'Z');
      var bl = $('[data-vg-cf-bedline]', box); bl.setAttribute('x1', x(b)); bl.setAttribute('x2', x(b));
      var dot = $('[data-vg-cf-dot]', box); dot.setAttribute('cx', x(d.dose)); dot.setAttribute('cy', y(level(d.list, d.dose + 0.01)));
      var total = MG + cups * CUP, atBed = Math.round(level(d.list, b));
      $('[data-vg-cf-train-out]', box).textContent = hh(Number(train.value));
      $('[data-vg-cf-bed-out]', box).textContent = hh(b);
      $('[data-vg-cf-total]', box).textContent = total + ' / 400 mg';
      var bar = $('[data-vg-cf-bar]', box); bar.style.transform = 'scaleX(' + Math.min(1, total / 400).toFixed(3) + ')'; bar.classList.toggle('is-high', total > 400);
      $('[data-vg-cf-res]', box).textContent = total > 400 ? tr('cf_over', { mg: total }) : tr('cf_take', { t: hh(d.dose) });
      $('[data-vg-cf-sleep]', box).textContent = tr(atBed > 100 ? 'cf_sleep_high' : 'cf_sleep_ok', { t: hh(b), mg: atBed });
    }
    $$('[data-vg-cf-cups]', box).forEach(function (bt) { bt.addEventListener('click', function () { cups = Number(bt.dataset.vgCfCups); $$('[data-vg-cf-cups]', box).forEach(function (o) { o.setAttribute('aria-pressed', String(o === bt)); }); draw(); }); });
    train.addEventListener('input', draw); bed.addEventListener('input', draw);
    draw();
  });

  /* ---------- Routine Builder ("Your day"): 24 h clock, moments from each label, overlap check vs EFSA upper levels ---------- */
  whenNear($('[data-vg-daylab]'), function (box) {
    var wake = $('[data-vg-day-wake]', box), bed = $('[data-vg-day-bed]', box);
    var picks = $$('[data-vg-day-p]', box), clock = $('[data-vg-day-clock]', box);
    var CX = 120, CY = 120, R = 92, ORDER = ['breakfast', 'lunch', 'dinner', 'bed1', 'bed30'];
    var UL = { d: 100, zn: 25, b6: 12 }, UNIT = { d: 'µg', zn: 'mg', b6: 'mg' };
    var hh = function (h) { h = ((h % 24) + 24) % 24; var q = Math.round(h * 4) / 4; return String(Math.floor(q) % 24).padStart(2, '0') + ':' + String(Math.round((q % 1) * 60)).padStart(2, '0'); };
    // noon at the top, midnight at the bottom
    var pt = function (h, r) { var a = (h - 12) / 24 * 2 * Math.PI; return [CX + (r || R) * Math.sin(a), CY - (r || R) * Math.cos(a)]; };
    var arc = function (h0, h1) { var a = pt(h0), b = pt(h1), span = ((h1 - h0) % 24 + 24) % 24; return 'M' + a[0].toFixed(1) + ' ' + a[1].toFixed(1) + 'A' + R + ' ' + R + ' 0 ' + (span > 12 ? 1 : 0) + ' 1 ' + b[0].toFixed(1) + ' ' + b[1].toFixed(1); };
    var svgEl = function (tag, attrs) { var e = document.createElementNS('http://www.w3.org/2000/svg', tag); Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); }); return e; };
    var ticks = $('[data-vg-day-ticks]', box);
    [0, 6, 12, 18].forEach(function (h) { var p = pt(h, 74); var t = svgEl('text', { x: p[0].toFixed(1), y: (p[1] + 4).toFixed(1) }); t.textContent = hh(h); ticks.appendChild(t); });
    var saved = store('vg-day');
    if (saved) { wake.value = saved.w; bed.value = saved.b; picks.forEach(function (b) { b.setAttribute('aria-pressed', String(saved.p.indexOf(b.dataset.vgDayP) > -1)); }); }
    var dotsG = $('[data-vg-day-dots]', box), list = $('[data-vg-day-list]', box), checks = $('[data-vg-day-checks]', box), buy = $('[data-vg-day-buy]', box);
    var dots = {};
    ORDER.forEach(function (m) {
      var g = svgEl('g', { 'class': 'vg-day__dot', 'data-m': m });
      g.appendChild(svgEl('circle', { r: 15 }));
      var img = svgEl('image', { x: -7, y: -14, width: 14, height: 28 }); g.appendChild(img);
      var badge = svgEl('text', { x: 12, y: -9, 'class': 'vg-day__badge' }); g.appendChild(badge);
      g.addEventListener('pointerenter', function () { hot(m, true); }); g.addEventListener('pointerleave', function () { hot(m, false); });
      dotsG.appendChild(g); dots[m] = { g: g, img: img, badge: badge };
    });
    function when(m, w, b) { return { breakfast: w + 0.5, lunch: w + 6, dinner: b - 3.5, bed1: b - 1, bed30: b - 0.5 }[m]; }
    function hot(m, on) { if (dots[m]) dots[m].g.classList.toggle('is-hot', on); $$('[data-m="' + m + '"]', list).forEach(function (li) { li.classList.toggle('is-hot', on); }); }
    function draw() {
      var w = Number(wake.value), b = Number(bed.value);
      var on = picks.filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; });
      store('vg-day', { w: w, b: b, p: on.map(function (p) { return p.dataset.vgDayP; }) });
      $('[data-vg-day-wake-out]', box).textContent = hh(w); $('[data-vg-day-bed-out]', box).textContent = hh(b);
      $('[data-vg-day-arc-day]', box).setAttribute('d', arc(w, b));
      $('[data-vg-day-arc-night]', box).setAttribute('d', arc(b, w + 24));
      [['wake', w], ['bed', b]].forEach(function (x) { var p = pt(x[1]); $('[data-vg-day-h="' + x[0] + '"]', box).setAttribute('transform', 'translate(' + p[0].toFixed(1) + ' ' + p[1].toFixed(1) + ')'); });
      // group the chosen products by moment
      var by = {}; on.forEach(function (p) { (by[p.dataset.at] = by[p.dataset.at] || []).push(p); });
      var moments = ORDER.filter(function (m) { return by[m]; });
      ORDER.forEach(function (m) {
        var d = dots[m], ps = by[m];
        d.g.style.opacity = ps ? 1 : 0;
        if (!ps) return;
        var p = pt(when(m, w, b), R + 26);
        d.g.style.transform = 'translate(' + p[0].toFixed(1) + 'px,' + p[1].toFixed(1) + 'px)';
        d.img.setAttribute('href', ps[0].dataset.img);
        d.badge.textContent = ps.length > 1 ? '+' + (ps.length - 1) : '';
      });
      $('[data-vg-day-n]', box).textContent = on.length;
      $('[data-vg-day-m]', box).textContent = tr('day_count', { m: moments.length });
      // the list
      list.innerHTML = '';
      if (!on.length) { var e = document.createElement('li'); e.className = 'vg-day__empty'; e.textContent = tr('day_none'); list.appendChild(e); }
      moments.slice().sort(function (x, y) { return when(x, w, b) - when(y, w, b); }).forEach(function (m) {
        var li = document.createElement('li'); li.dataset.m = m;
        var time = document.createElement('time'); time.textContent = hh(when(m, w, b));
        var lab = document.createElement('span'); lab.className = 'vg-day__when'; lab.textContent = tr('day_m_' + m);
        var items = document.createElement('span'); items.className = 'vg-day__items';
        by[m].forEach(function (p) {
          var a = document.createElement('a'); a.href = p.dataset.url;
          var im = document.createElement('img'); im.src = p.dataset.img; im.alt = ''; im.width = 14; im.height = 28; im.loading = 'lazy';
          a.appendChild(im); a.appendChild(document.createTextNode($('b', p).textContent + ' · ' + $('small', p).textContent));
          items.appendChild(a);
        });
        li.appendChild(time); li.appendChild(lab); li.appendChild(items);
        li.addEventListener('pointerenter', function () { hot(m, true); }); li.addEventListener('pointerleave', function () { hot(m, false); });
        list.appendChild(li);
      });
      // overlap check: a nutrient that comes from two products, and melatonin twice
      var tot = {}, cnt = {}; on.forEach(function (p) { var n = JSON.parse(p.dataset.n || '{}'); Object.keys(n).forEach(function (k) { tot[k] = (tot[k] || 0) + n[k]; cnt[k] = (cnt[k] || 0) + 1; }); });
      checks.innerHTML = '';
      var any = false;
      Object.keys(UL).forEach(function (k) {
        if ((cnt[k] || 0) < 2) return; any = true;
        var row = document.createElement('div'); row.className = 'vg-sat';
        var head = document.createElement('span'); head.className = 'vg-sat__h';
        var l = document.createElement('b'); l.textContent = tr('day_n_' + k);
        var r = document.createElement('b'); r.textContent = fmt(tot[k], 1) + ' / ' + UL[k] + ' ' + UNIT[k];
        head.appendChild(l); head.appendChild(r);
        var bar = document.createElement('i'); var fill = document.createElement('span'); bar.appendChild(fill);
        var note = document.createElement('span'); note.className = 'vg-small'; note.textContent = tr('day_ul', { v: fmt(tot[k], 1) + ' ' + UNIT[k], max: UL[k] + ' ' + UNIT[k] });
        row.appendChild(head); row.appendChild(bar); row.appendChild(note); checks.appendChild(row);
        requestAnimationFrame(function () { fill.style.transform = 'scaleX(' + Math.min(1, tot[k] / UL[k]).toFixed(3) + ')'; fill.classList.toggle('is-high', tot[k] > UL[k]); });
      });
      if ((cnt.mel || 0) > 1) { any = true; var mw = document.createElement('p'); mw.className = 'vg-day__warn'; mw.textContent = tr('day_mel'); checks.appendChild(mw); }
      if (!any && on.length > 1) { var ok = document.createElement('p'); ok.className = 'vg-done'; ok.textContent = '✓ ' + tr('day_ok'); checks.appendChild(ok); }
      // buy
      var sum = on.reduce(function (s, p) { return s + Number(p.dataset.price || 0); }, 0);
      buy.disabled = !on.length;
      buy.textContent = on.length ? tr('day_buy', { n: on.length, p: money(sum) }) : tr('day_none');
    }
    picks.forEach(function (p) { p.addEventListener('click', function () { p.setAttribute('aria-pressed', String(p.getAttribute('aria-pressed') !== 'true')); draw(); }); });
    wake.addEventListener('input', draw); bed.addEventListener('input', draw);
    // drag the sun (wake) or the moon (bed) around the clock
    $$('[data-vg-day-h]', box).forEach(function (h) {
      var input = h.dataset.vgDayH === 'wake' ? wake : bed;
      h.addEventListener('pointerdown', function (e) {
        e.preventDefault(); h.setPointerCapture(e.pointerId); h.classList.add('is-drag');
        var move = function (ev) {
          var r = clock.getBoundingClientRect(), x = (ev.clientX - r.left) / r.width * 292 - 26 - CX, y = (ev.clientY - r.top) / r.height * 292 - 26 - CY;
          var hrs = (Math.atan2(x, -y) / (2 * Math.PI) * 24 + 12 + 24) % 24;
          var min = Number(input.min), max = Number(input.max);
          if (hrs < min - 3) hrs += 24; // bedtimes after midnight
          input.value = Math.min(max, Math.max(min, Math.round(hrs * 4) / 4)); draw();
        };
        var up = function () { h.classList.remove('is-drag'); h.removeEventListener('pointermove', move); h.removeEventListener('pointerup', up); h.removeEventListener('pointercancel', up); };
        h.addEventListener('pointermove', move); h.addEventListener('pointerup', up); h.addEventListener('pointercancel', up);
      });
    });
    buy.addEventListener('click', function () {
      var items = picks.filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; }).map(function (p) { return { id: Number(p.dataset.variant), quantity: 1 }; });
      if (items.length) addToCart(items, $('[data-vg-status]', box), buy);
    });
    box.addEventListener('vg-day-set', function (e) { picks.forEach(function (p) { p.setAttribute('aria-pressed', String(e.detail.indexOf(p.dataset.vgDayP) > -1)); }); draw(); });
    draw();
  });

  // quiz results with data-vg-day-set put their products on the Routine Builder clock (also before the lab has started)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-vg-day-set]'); if (!a) return;
    var keys = a.dataset.vgDaySet.split(' '), prev = store('vg-day') || { w: 7, b: 23.5 };
    store('vg-day', { w: prev.w, b: prev.b, p: keys });
    var lab = $('[data-vg-daylab]'); if (lab) lab.dispatchEvent(new CustomEvent('vg-day-set', { detail: keys }));
  });

  /* ---------- product card + sticky bar buttons ---------- */
  $$('[data-vg-add]').forEach(function (btn) {
    btn.addEventListener('click', function () { if (chosen) addToCart([{ id: Number(chosen.variant), quantity: 1 }], $('[data-vg-status]', btn.closest('[data-vg-buybox]') || document), btn); });
  });

  /* ---------- myth / fact cards ---------- */
  $$('.vg-flip').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); c.addEventListener('click', function () { c.setAttribute('aria-pressed', String(c.getAttribute('aria-pressed') !== 'true')); }); });

  /* ---------- quiz ---------- */
  $$('[data-vg-quiz]').forEach(function (q) {
    var steps = $$('[data-vg-step]', q), dots = $('[data-vg-dots]', q), score = {};
    steps.forEach(function (s, i) { s.hidden = i > 0; if (dots) { var d = document.createElement('i'); if (!i) d.className = 'is-on'; dots.appendChild(d); } });
    $$('[data-vg-a]', q).forEach(function (b) {
      b.classList.add('vg-opt'); b.type = 'button';
      b.addEventListener('click', function () {
        (b.dataset.vgA || '').split(' ').forEach(function (k) { if (k) score[k] = (score[k] || 0) + 1; });
        var cur = b.closest('[data-vg-step]'), i = steps.indexOf(cur);
        cur.hidden = true;
        if (i + 1 < steps.length) { steps[i + 1].hidden = false; if (dots) dots.children[i + 1].className = 'is-on'; var nb = $('[data-vg-a]', steps[i + 1]); if (nb) nb.focus({ preventScroll: true }); }
        else {
          var best = Object.keys(score).sort(function (a, b2) { return score[b2] - score[a]; })[0];
          var r = $('[data-vg-r="' + best + '"]', q) || $('[data-vg-r]', q);
          if (r) { r.hidden = false; r.setAttribute('tabindex', '-1'); r.focus({ preventScroll: true }); }
          if (dots) dots.hidden = true;
        }
      });
    });
    $$('[data-vg-restart]', q).forEach(function (b) { b.addEventListener('click', function () { score = {}; $$('[data-vg-r]', q).forEach(function (r) { r.hidden = true; }); steps.forEach(function (s, i) { s.hidden = i > 0; }); if (dots) { dots.hidden = false; $$('i', dots).forEach(function (d, i) { d.className = i ? '' : 'is-on'; }); } }); });
  });

  /* ---------- shake builder ---------- */
  whenNear($('[data-vg-shake]'), function (box) {
    var opts = C.shake || {};
    var state = { base: 'milk', scoops: 1, adds: {} };
    function total() {
      var g = (opts.base && opts.base[state.base] ? opts.base[state.base].p : 0) + state.scoops * (C.scoopProtein || 23);
      Object.keys(state.adds).forEach(function (k) { if (state.adds[k] && opts.adds[k]) g += opts.adds[k].p; });
      return Math.round(g);
    }
    function draw() {
      $$('[data-vg-base]', box).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.vgBase === state.base)); });
      $$('[data-vg-scoops]', box).forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.vgScoops) === state.scoops)); });
      $$('[data-vg-add-in]', box).forEach(function (b) { b.setAttribute('aria-pressed', String(!!state.adds[b.dataset.vgAddIn])); });
      // layers: base liquid, powder band, one band per add-in
      var layers = [{ c: (opts.base[state.base] || {}).c || '#ddd', h: 96 }, { c: chosen && chosen.color || '#e9dcc0', h: 24 * state.scoops }];
      Object.keys(state.adds).forEach(function (k) { if (state.adds[k] && opts.adds[k]) layers.push({ c: opts.adds[k].c, h: 16 }); });
      var y = 250, svg = $('[data-vg-layers]', box), html = '';
      layers.forEach(function (l, i) { var h = Math.min(l.h, y - 52); y -= h; html += '<rect class="layer" x="34" y="' + y + '" width="132" height="' + h + '" fill="' + l.c + '" style="transform:scaleY(1);opacity:' + (i ? .95 : .9) + '"/>'; });
      svg.innerHTML = html;
      if (!reduce) $$('.layer', svg).forEach(function (r, i) { r.style.transform = 'scaleY(0)'; requestAnimationFrame(function () { setTimeout(function () { r.style.transform = 'scaleY(1)'; }, i * 90); }); });
      var g = total();
      $('[data-vg-shake-total]', box).textContent = fmt(g) + ' g';
      var lab = window.vgLab, cov = $('[data-vg-shake-cover]', box);
      cov.textContent = lab && lab.need ? tr('shake_cover', { p: Math.round(g / lab.need * 100) }) : tr('shake_cover_none');
    }
    $$('[data-vg-base]', box).forEach(function (b) { b.addEventListener('click', function () { state.base = b.dataset.vgBase; draw(); }); });
    $$('[data-vg-scoops]', box).forEach(function (b) { b.addEventListener('click', function () { state.scoops = Number(b.dataset.vgScoops); draw(); }); });
    $$('[data-vg-add-in]', box).forEach(function (b) { b.addEventListener('click', function () { state.adds[b.dataset.vgAddIn] = !state.adds[b.dataset.vgAddIn]; draw(); }); });
    document.addEventListener('vg:lab', function () { var cov = $('[data-vg-shake-cover]', box); if (cov) draw(); });
    draw();
  });

  /* ---------- free-gift hint at the end ---------- */
  function paintGift(cart) {
    var el = $('[data-vg-gift]'); if (!el || !window.vpxGiftInfo) return;
    var g = window.vpxGiftInfo(cart);
    if (g.won) { el.innerHTML = '🎁 <b>' + tr('gift_won') + '</b>'; }
    else { el.innerHTML = '🎁 ' + tr('gift_left', { a: '<b>' + money(g.left) + '</b>' }); }
    el.hidden = false;
  }
  if ($('[data-vg-gift]')) whenNear($('[data-vg-gift]'), function () { fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(paintGift).catch(function () {}); });
  document.addEventListener('vpx:gift', function (e) { if (e.detail && e.detail.cart) paintGift(e.detail.cart); });

  /* ---------- plan summary at the end (from the Lab) ---------- */
  var plan = $('[data-vg-plan]');
  function paintPlan(s) { if (!plan || !s || !s.need) return; plan.textContent = s.scoops > 0 ? tr(s.scoops === 1 ? 'plan_line_one' : 'plan_line', { g: s.need, n: fmt(s.scoops, 1), d: Math.floor((C.servings || 33) / s.scoops) }) : tr('lab_food_ok'); }
  paintPlan(store('vg-lab')); document.addEventListener('vg:lab', function (e) { paintPlan(e.detail); });

  /* ---------- sticky buy bar on phones ---------- */
  var sticky = $('[data-vg-sticky]'), start = $('[data-vg-sticky-start]'), end = $('[data-vg-end]');
  if (sticky && start) {
    var sTick = false, sOn = null, inView = 0;
    // stay out of the way while one of the guide's own buy buttons is on screen (it covered them on small phones, audit 2026-10-23)
    if ('IntersectionObserver' in window) {
      var seen = new Set();
      var bio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); }); inView = seen.size; sOn = null; upd(); }, { threshold: 0 });
      $$('.vg-content [data-vg-buybox] .vg-btn--primary, .vg-content [data-vg-day-buy]').forEach(function (b) { bio.observe(b); });
    }
    var upd = function () {
      sTick = false;
      var on = !inView && start.getBoundingClientRect().top < -200 && (!end || end.getBoundingClientRect().top > window.innerHeight);
      if (on === sOn) return; sOn = on;
      sticky.classList.toggle('is-on', on); sticky.inert = !on;
    };
    window.addEventListener('scroll', function () { if (!sTick) { sTick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* ---------- was this helpful? ---------- */
  $$('[data-vg-vote]').forEach(function (box) {
    var key = 'vg-vote-' + (C.article || '');
    var prev = null; try { prev = localStorage.getItem(key); } catch (e) {}
    $$('button', box).forEach(function (b) {
      if (prev === b.dataset.v) b.setAttribute('aria-pressed', 'true');
      b.addEventListener('click', function () {
        if (prev) return; prev = b.dataset.v;
        try { localStorage.setItem(key, prev); } catch (e) {}
        b.setAttribute('aria-pressed', 'true');
        var msg = $('[data-vg-vote-msg]', box); if (msg) msg.textContent = tr('vote_thanks');
        if (C.feedbackUrl) fetch(C.feedbackUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ page: C.article, vote: prev }), keepalive: true }).catch(function () {});
      });
    });
  });

  /* =================== hub =================== */
  var hub = $('[data-vgh]');
  if (hub) {
    var glow = $('.vgh__glow', hub);
    if (glow && fine && !reduce) {
      var graf = 0;
      hub.addEventListener('pointermove', function (e) { var r = hub.getBoundingClientRect(); cancelAnimationFrame(graf); graf = requestAnimationFrame(function () { glow.style.setProperty('--gx', (e.clientX - r.left) + 'px'); glow.style.setProperty('--gy', (e.clientY - r.top) + 'px'); }); });
    }
    var cards = $$('.vgh-card', hub), chips = $$('[data-vgh-f]', hub);
    // while the page or the carousel scrolls, the cards' effects hold still (smooth scrolling on phones); they resume 160 ms later
    var sT = 0, onScroll = function () { if (!hub.classList.contains('is-scrolling')) hub.classList.add('is-scrolling'); clearTimeout(sT); sT = setTimeout(function () { hub.classList.remove('is-scrolling'); }, 160); };
    window.addEventListener('scroll', onScroll, { passive: true }); var track = $('.vgh__cards', hub); if (track) track.addEventListener('scroll', onScroll, { passive: true });
    // the cards' light and floating jars only run while the card is on screen
    if ('IntersectionObserver' in window) { var vio = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('is-vis', e.isIntersecting); }); }, { rootMargin: '80px' }); cards.forEach(function (k) { vio.observe(k); }); } else cards.forEach(function (k) { k.classList.add('is-vis'); });
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var f = c.dataset.vghF;
        var apply = function () {
          chips.forEach(function (x) { x.setAttribute('aria-pressed', String(x === c)); });
          cards.forEach(function (k) { k.hidden = !(f === 'all' || k.dataset.cat === f); });
        };
        if (document.startViewTransition && !reduce) document.startViewTransition(apply); else apply();
      });
    });
    if (fine && !reduce) {
      cards.forEach(function (k) {
        var raf2 = 0;
        k.addEventListener('pointermove', function (e) {
          var r = k.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          cancelAnimationFrame(raf2); raf2 = requestAnimationFrame(function () {
            k.style.setProperty('--ry', ((x - .5) * 12).toFixed(2) + 'deg'); k.style.setProperty('--rx', ((.5 - y) * 10).toFixed(2) + 'deg');
            k.style.setProperty('--gx', (x * 100).toFixed(1) + '%'); k.style.setProperty('--gy', (y * 100).toFixed(1) + '%');
          });
        });
        k.addEventListener('pointerleave', function () { k.style.setProperty('--rx', '0deg'); k.style.setProperty('--ry', '0deg'); });
      });
    }
  }
})();
